import React from 'react';
import { graphql } from 'gatsby';
import Divider from '@solid-ui-components/Divider';
import {
  normalizeBlockContentNodes,
  useHighlightAnchors,
} from '@blocks-helpers';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import { Flex } from 'theme-ui';
import KnowledgeBaseArticleInfoBlock from '@solid-ui-blocks/KnowledgeBaseArticleInfoBlock';
import KnowledgeBaseArticleNav from '@solid-ui-blocks/KnowledgeBaseArticleNav';
import styles from './_styles';
import KnowledgeBaseArticleAside from '@solid-ui-blocks/KnowledgeBaseArticleAside';
import KnowledgeBaseArticleMobileNav from '@solid-ui-blocks/KnowledgeBaseArticleMobileNav';
import { Helmet } from 'react-helmet';

const KnowledgeBaseUsers = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  const anchors = [
    'creating-a-user',
    'editing-and-archiving-users',
    'tips-for-managing-users',
  ];

  useHighlightAnchors(anchors);

  return (
    <>
    <Helmet>
      <link rel="canonical" href={`https://targpatrol.com/knowledge-base-users/`} />
    </Helmet>
    <BasePage
      description={
        'Learn how to create and set up a user in TARGPatrol. Manage employees in the task tracker: how to edit, delete, or assign roles for better task management.'
      }
      title={'Creating a user account in TARGPatrol'}
      keywords={'task management, task tracker, free task management software, task tracking tools, best task tracking app, task and project management software, project management software task tracking, inspection app, workplace inspection checklist, safety inspection checklist'.split(
        ', '
      )}
      pathname={pathname}
      {...props}
    >
      <LayoutWrapper divider={<Divider />}>
        <>
          <KnowledgeBaseArticleNav content={content['nav']} />
          <KnowledgeBaseArticleMobileNav content={content['mobile-nav']} />
          <Flex sx={styles.articleContainer}>
            <Flex as='main' sx={styles.articleMain}>
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-1']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-2']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-3']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-4']}
              />
            </Flex>
            <KnowledgeBaseArticleAside content={content['aside']} />
          </Flex>
        </>
      </LayoutWrapper>
    </BasePage>
    </>
  );
};

export const query = graphql`
  query knowledgeBaseUsersTargpatrolEnBlockContent {
    allBlockContent(
      filter: { page: { in: ["targpatrol-en/knowledge-base-users", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`;
export default KnowledgeBaseUsers;
